import React, { useEffect } from "react";
import Qns from "../../Services/Qns";
import Contactform from "../../About/Contactform";
import Servicebanner from "../../Services/Servicebanner";
import Infobox from "../../About/Infobox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import EmergencyServicescon from "./EmergencyServicescon";
import Infiry from "../../About/Infiry";
import Callin from "../../About/Callin";
import { movetop } from "../../../fun";
import { Helmet } from "react-helmet-async";

function EmergencyServices() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <EmergencyServicescon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };
  const elemnt2: elem = {
    oneBody: <Qns />,
    twoBody: <Contactform />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Emergency Treatment in Whitefield</title>
        <meta
          name="description"
          content="We give the best Emergency Treatment in Whitefield and Vijayanagar. Feel free to contact us if you have any emergency."
        />
        <meta
          name="keywords"
          content="Best Emergency Treatment in Whitefield, Best Emergency Treatment in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestemergencyservicesinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestemergencyservicesinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers rapid and comprehensive emergency medical services including triage, urgent care, trauma response, acute illness management, minor surgical interventions, and stabilization by trained emergency care providers.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Emergency triage and urgent medical assessment",
              "Acute illness and trauma care",
              "Stabilization and monitoring",
              "Minor urgent procedures and suturing",
              "Pain management and first response care",
              "Coordination for ambulance support",
              "Follow-up care planning",
            ],
            keywords: [
              "best emergency services in Immadihalli",
              "best emergency services in Whitefield",
              "best emergency services in Bangalore",
              "best emergency services in Kundalahalli",
              "best emergency services in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>Emergency Treatment in Whitefield</h2>
      <Servicebanner name="Emergency Services" banner={"../photo/dd12.jpg"} />
      <Infobox />
      {/* <Doctorbox /> */}
      <div className="flex justify-center py-6">
        <div className="containerbox">
          <p className="mb-4">
            As of my last knowledge update in January 2023, I don't have
            specific details about ELV Health Care Polyclinics' emergency
            services. However, I can provide you with a general outline of what
            emergency services at a healthcare facility might include. For the
            most accurate and up-to-date information, I recommend checking
            directly with ELV Health Care Polyclinics through their official
            channels. Here's a general point-wise outline:
          </p>
        </div>
      </div>
      <Divser elemnt={elemnt} />

      <div className="pt-10 pb-10">
        <Divider />
      </div>
      <Divser elemnt={elemnt2} />

      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default EmergencyServices;
